/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	class RecommendedDriversUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1024;
		}

		/**
		 * Perform upgrade for recommendedDrivers which might have the label property on earlier versions.
		 * the 'label' property has been removed from the spec as it is not needed.
		 *
		 * @param {object} spec - spec to perform upgrade on
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {

			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			return this._upgradeWidgets(spec);

		}

		down(spec) {
			// Downgrades are not available in CA
			return Promise.resolve(spec);
		}

		_upgradeWidgets(spec) {
			_.each(spec.widgets, model => {
				this._upgradeWidget(model);
			});
			return Promise.resolve(spec);
		}

		_upgradeWidget(model) {
			if (!model.possibleKeyDrivers) {
				return;
			}
			let possibleKeyDrivers = _.values(model.possibleKeyDrivers);
			_.each(possibleKeyDrivers, keyDriver => {
				let recDrivers = keyDriver.recommendedDrivers ? keyDriver.recommendedDrivers : null;
				recDrivers && _.each(recDrivers, driver => {
					driver.label && delete driver.label;
				});
			});
		}

	}

	return new RecommendedDriversUpgrade();

});
